import VehicleExtras from 'components/form/VehicleExtras/styled';

export default VehicleExtras;
